import { newsApi } from './api';
import {
    ADD_EXPENCE_ENDPOINT,
    GET_EXPENCE_ENDPOINT,
    EXPENCE_EDIT_ENDPOINT,
    REMOVE_EXPENCE_ENDPOINT,
    GET_EXPENCE_STATISTIC_ENDPOINT
} from "./apiConstant";

export const ExpenceService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getExpenceStatistics: build.query({
            query: (id) => ({
                url: `${GET_EXPENCE_STATISTIC_ENDPOINT}/${id ? id : 0}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        getExpence: build.query({
            query: ({ id, pagination }) => ({
                url: `${GET_EXPENCE_ENDPOINT}/${id ? id : 0}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addExpence: build.mutation({
            query: (form) => ({
                url: `${ADD_EXPENCE_ENDPOINT}`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editExpence: build.mutation({
            query: ({ id, newForm }) => ({
                url: `${EXPENCE_EDIT_ENDPOINT}/${id}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removeExpence: build.mutation({
            query: (id) => ({
                url: `${REMOVE_EXPENCE_ENDPOINT}/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetExpenceStatisticsQuery,
    useGetExpenceQuery,
    useAddExpenceMutation,
    useEditExpenceMutation,
    useRemoveExpenceMutation,
} = ExpenceService